// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledString from '../../../shared/components/labeled-string';
import RgaSearchResults from '../state/rga-search-result';
import {buildDate} from '../../../shared/services/build-date';
import {findValueKeyPair} from '../../shared/services/rga-utils';

export const buildPartReturnString = partRequest => `${partRequest.partNumber} - ${partRequest.partDescription}`;

function getStatusList(props) {

    // Find the key-value pair in the list that matches the text value.

    if (props.item.rgaSubType === 'PICT') {

        const pair = findValueKeyPair(props.photoReqStatus, props.item.rgaStatus);

        return pair.value;

    } else if (props.item.rgaSubType === 'INFO') {

        const pair = findValueKeyPair(props.infoReqStatus, props.item.rgaStatus);

        return pair.value;

    } else if (props.item.rgaSubType === 'PART') {

        const pair = findValueKeyPair(props.partReqStatus, props.item.rgaStatus);

        return pair.value;

    }
    return '';

}
const RgaInfo = props =>
    <div className='rga-info'>
        <div className='row'>
            <LabeledString
                className='rolling-month-credit'
                data={buildPartReturnString(props.item)}
                label='Requested Part'
            />
            <LabeledString
                className='due-date'
                data={props.item.warrantyClaimNumber}
                label='CLAIM'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='rolling-month-credit'
                data={props.item.rgaSubType}
                label='RGA SubType'
            />
            <LabeledString
                className='due-date'
                data={props.item.rgaDealer}
                label='DEALER'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='rolling-month-credit'
                data={props.item.dtacCaseNumber}
                label='DTAC_CASE'
            />
            <LabeledString
                className='due-date'
                data={getStatusList(props)}
                label='STATUS'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='rolling-month-credit'
                data={buildDate(props.item.requestDate)}
                label='REQUESTED'
            />
            <LabeledString
                className='rolling-month-credit'
                data={props.item.subSystem}
                label='Sub System'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='rolling-month-credit'
                data={props.item.machineSerialNumber}
                label='Pin'
            />
            <LabeledString
                className='due-date'
                data={props.item.analystId}
                label='Analyst'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='rolling-month-credit'
                data={props.item.engineSerialNumber}
                label='Engine SN'
            />
            <LabeledString
                className='rolling-month-credit'
                data={props.item.rgaNumber}
                label='RGA Number'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='due-date'
                data={props.item.shippedToLocation}
                label='SHIP_TO'
            />
        </div>
    </div>;

RgaInfo.displayName = 'RgaInfo';
RgaInfo.propTypes = {
    infoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    item: PropTypes.instanceOf(RgaSearchResults).isRequired,
    partReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    photoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default RgaInfo;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/components/rga-info.js